/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import AssertionError from 'assertion-error';

// @ts-ignore Není to ESM.
import contentErrorOverlayHtml from './content-error-overlay.html';
// @ts-ignore Není to ESM.
import hourglassSvg from './hourglass-solid.svg';
// @ts-ignore Není to ESM.
import fileCircleQuestionSvg from './file-circle-question-solid.svg';
// @ts-ignore Není to ESM.
import videoSlashSvg from './video-slash-solid.svg';

import ErrorName from '../../error/error-name';
import ScheduleContent, { ContentType } from '../../schedule/schedule-content';

/**
 * @import { Content } from '../content'
 * @import { Layout } from '../../layout/layout'
 * @import { Medium } from '../../medium/medium'
 * @import { Playlist } from '../../playlist/playlist'
 */

/**
 * Vygeneruje HTMLElement s piktogramem.
 * @param {Error} err Typ chyby, pro který se má vytvořit piktogram.
 * @param {Content} content Obsah, pro který se vyskytla chyba.
 * @returns {ChildNode} Vytvořený element s piktogramem.
 * @throws {AssertionError}
 */
export function generatePlayErrorElem(err, content) {
  /** @type {string | undefined} */
  let contentId;
  switch (ScheduleContent.type(content)) {
    case ContentType.Layout:
      contentId = /** @type {Layout} */ (content.layout).id;
      break;
    case ContentType.Medium:
      contentId = /** @type {Medium} */ (content.medium).id;
      break;
    case ContentType.Playlist:
      contentId = /** @type {Playlist} */ (content.playlist).id;
      break;
    default:
      throw new AssertionError('Unknown content type.');
  }

  let imageSrc;
  switch (err.name) {
    case ErrorName.SeekError:
      imageSrc = hourglassSvg;
      break;
    case ErrorName.MissingMediumError:
    case ErrorName.EnterPlayingError:
    case ErrorName.UnsupportedMimeTypeError:
      imageSrc = videoSlashSvg;
      break;
    default:
      imageSrc = fileCircleQuestionSvg;
      break;
  }

  const parser = new DOMParser();
  const container = parser.parseFromString(
    contentErrorOverlayHtml,
    'text/html'
  );

  const root = container.getElementById('content-error-overlay-container');
  const el = container.body.firstChild;
  if (el === null || root === null) {
    throw new AssertionError('missing root element');
  }

  const errorImg = /** @type {HTMLImageElement | null} */ (
    container.getElementById('content-error-overlay-img')
  );
  if (errorImg === null) {
    throw new AssertionError('missing img element');
  }

  const errorMessage = container.getElementById(
    'content-error-overlay-message'
  );
  if (errorMessage === null) {
    throw new AssertionError('missing message element');
  }

  Object.assign(root.style, {
    top: '0',
    left: '0',
    zIndex: '1',
    width: '100%',
    height: '100%'
  });

  errorImg.src = imageSrc;
  errorMessage.textContent = `${contentId}`;
  return el;
}
